import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useUpgradePromptOpen } from "@/shared/lib/hooks/useUpgradePrompt";
import { closeUpgradePrompt } from "@/shared/lib/upgradePrompt";
import { UpgradeModal } from "@/shared/ui";

/**
 * Connects the global upgrade-prompt store to the shared `UpgradeModal`: the
 * `api/` 402 interceptor opens the store, this renders the modal and routes the
 * primary action to `/pricing`. Mounted once at the app root.
 */
export function UpgradeModalHost() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const open = useUpgradePromptOpen();

  return (
    <UpgradeModal
      open={open}
      onClose={closeUpgradePrompt}
      title={t("upgrade.title")}
      description={t("upgrade.description")}
      primaryLabel={t("upgrade.seePlans")}
      secondaryLabel={t("upgrade.notNow")}
      closeLabel={t("common.close")}
      onPrimary={() => {
        closeUpgradePrompt();
        void navigate({ to: "/pricing" });
      }}
    />
  );
}
